
import { Select, SelectContent } from '@dextech-ai/dex-design-system'
import { applySelectedValues, getSelectedValues, renderSelectItems } from '@/utils/select-items'
import PropTypes from 'prop-types';

const OverViewFilterSelect = ({ items, onChange, 'data-testid': dataTestId }) => {
	return (
		<Select
			multiple
			placeholder="Select"
			maxTagCount="responsive"
			notFoundContent="This is empty"
			data-testid={dataTestId}
			popupMatchSelectWidth={false}
			style={{ width: 163 }}
			value={getSelectedValues(items)}
			onChange={(values) => onChange(applySelectedValues(items, values))}
		>
			<SelectContent>{renderSelectItems(items)}</SelectContent>
		</Select>
	)
}

OverViewFilterSelect.propTypes = {
	items: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	'data-testid': PropTypes.string,
};

export default OverViewFilterSelect
